// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Head & Upload ───────────────────────────── */
.hrcalendar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hrcalendar-title { margin-bottom: 0; }
.hrcalendar-upload-card { margin-bottom: 12px; }
.hrcalendar-upload-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.hrcalendar-file { max-width: 280px; margin-bottom: 0; }
.hrcalendar-demo-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.hrcalendar-demo-table { min-width: 900px; margin-bottom: 0; }
.hrcalendar-demo-cell { font-size: 11px; }

/* ── Nav & Month ─────────────────────────────── */
.hrcalendar-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hrcalendar-month {
  font-family: "Outfit", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

/* ── Grid ────────────────────────────────────── */
.hrcalendar-grid {
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px 4px;
}
.hrcalendar-weekday {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  text-align: center;
  padding: 4px 6px 8px;
}
.hrcalendar-weekday.is-weekend { color: #f87171; }

/* ── Cell ────────────────────────────────────── */
.hrcalendar-cell-wrap { padding: 0 2px; vertical-align: top; }

.hrcalendar-cell {
  width: 100%;
  min-height: 64px;
  padding: 8px 6px 6px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  background: #f8fafc;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  transition: all 0.15s ease;
}
.hrcalendar-cell:hover {
  background: #eff6ff;
  border-color: #bfdbfe;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59,130,246,0.10);
}
.hrcalendar-cell.is-weekend {
  background: #fefce8;
}
.hrcalendar-cell.is-weekend:hover {
  background: #fef9c3;
  border-color: #fde68a;
}
.hrcalendar-cell.is-today {
  background: #eef2ff;
  border-color: #6366f1;
  box-shadow: 0 0 0 2px #e0e7ff;
}
.hrcalendar-cell.is-selected {
  background: #f0fdf4;
  border-color: #22c55e;
  box-shadow: 0 0 0 2px #dcfce7;
}

/* Date number */
.hrcalendar-cell-date {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}
.hrcalendar-cell.is-today .hrcalendar-cell-date {
  color: #4f46e5;
}
.hrcalendar-cell.is-weekend .hrcalendar-cell-date {
  color: #b45309;
}

/* ── Dots ────────────────────────────────────── */
.hrcalendar-dots {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  justify-content: center;
  min-height: 8px;
}

.hrcalendar-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* Dot colors by event type */
.hrcalendar-dot--event     { background: #6366f1; }
.hrcalendar-dot--holiday   { background: #ef4444; }
.hrcalendar-dot--milestone { background: #f59e0b; }
.hrcalendar-dot--training  { background: #0ea5e9; }
.hrcalendar-dot--deadline  { background: #f43f5e; }
.hrcalendar-dot--meeting   { background: #8b5cf6; }

.hrcalendar-dot-more {
  font-size: 9px;
  font-weight: 700;
  color: #64748b;
  line-height: 1;
  margin-top: 1px;
}

.hrcalendar-empty { min-height: 64px; }

/* ── Selected Date Detail Panel ──────────────── */
.hrcalendar-detail-panel {
  margin-top: 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  overflow: hidden;
  animation: hrcal-slidein 0.18s ease;
}

@keyframes hrcal-slidein {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.hrcalendar-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #e2e8f0;
}
.hrcalendar-detail-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", sans-serif;
}
.hrcalendar-detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #94a3b8;
  padding: 2px 6px;
  border-radius: 6px;
  transition: all .15s;
}
.hrcalendar-detail-close:hover {
  background: #fee2e2;
  color: #ef4444;
}

.hrcalendar-detail-empty {
  padding: 20px 16px;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

.hrcalendar-detail-list {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hrcalendar-detail-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid transparent;
}
.hrcalendar-detail-card--event {
  background: #f5f3ff;
  border-color: #ddd6fe;
}
.hrcalendar-detail-card--holiday {
  background: #fef2f2;
  border-color: #fecaca;
}
.hrcalendar-detail-card--milestone {
  background: #fffbeb;
  border-color: #fde68a;
}
.hrcalendar-detail-card--training {
  background: #f0f9ff;
  border-color: #bae6fd;
}
.hrcalendar-detail-card--deadline {
  background: #fff1f2;
  border-color: #fecdd3;
}

.hrcalendar-detail-card-left {
  padding-top: 3px;
}
.hrcalendar-detail-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.hrcalendar-detail-card-body { flex: 1 1; }
.hrcalendar-detail-card-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 3px;
}
.hrcalendar-detail-card-meta {
  font-size: 11.5px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.hrcalendar-detail-card-desc {
  margin-top: 6px;
  font-size: 12.5px;
  color: #334155;
  line-height: 1.5;
}

/* ── Upcoming Events ─────────────────────────── */
.hrcalendar-upcoming {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}
.hrcalendar-upcoming-title {
  font-size: 15px;
  font-weight: 700;
  font-family: "Outfit", sans-serif;
  margin-bottom: 8px;
  color: #1e293b;
}
.hrcalendar-empty-upcoming {
  color: #94a3b8;
  font-size: 13px;
}
.hrcalendar-upcoming-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}
.hrcalendar-upcoming-row:last-child { border-bottom: none; }
.hrcalendar-upcoming-date {
  font-size: 12px;
  color: #64748b;
  min-width: 90px;
  font-weight: 600;
}
.hrcalendar-upcoming-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

/* ── Create actions ──────────────────────────── */
.hrcalendar-create-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

/* ── Responsive ──────────────────────────────── */
@media (max-width: 900px) {
  .hrcalendar-month { font-size: 18px; }
  .hrcalendar-cell  { min-height: 52px; padding: 6px 4px 4px; }
  .hrcalendar-cell-date { font-size: 12px; }
  .hrcalendar-dot { width: 6px; height: 6px; }
  .hrcalendar-upcoming-row { flex-wrap: wrap; }
  .hrcalendar-upcoming-date { min-width: unset; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrCalendarPg.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,oBAAoB,gBAAgB,EAAE;AACtC,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE;AACvD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,yBAAyB,gBAAgB,EAAE,gBAAgB,EAAE;AAC7D,wBAAwB,eAAe,EAAE;;AAEzC,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;AACA,iCAAiC,cAAc,EAAE;;AAEjD,mDAAmD;AACnD,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;;AAE7D;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB,gBAAgB,EAAE;;AAEtC,mDAAmD;AACnD;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA,+BAA+B,SAAO,EAAE;AACxC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;AACA,sCAAsC,mBAAmB,EAAE;AAC3D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,oBAAoB,eAAe,EAAE;EACrC,oBAAoB,gBAAgB,EAAE,oBAAoB,EAAE;EAC5D,wBAAwB,eAAe,EAAE;EACzC,kBAAkB,UAAU,EAAE,WAAW,EAAE;EAC3C,2BAA2B,eAAe,EAAE;EAC5C,4BAA4B,gBAAgB,EAAE;AAChD","sourcesContent":["/* ── Head & Upload ───────────────────────────── */\n.hrcalendar-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.hrcalendar-title { margin-bottom: 0; }\n.hrcalendar-upload-card { margin-bottom: 12px; }\n.hrcalendar-upload-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n.hrcalendar-file { max-width: 280px; margin-bottom: 0; }\n.hrcalendar-demo-wrap {\n  overflow-x: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n.hrcalendar-demo-table { min-width: 900px; margin-bottom: 0; }\n.hrcalendar-demo-cell { font-size: 11px; }\n\n/* ── Nav & Month ─────────────────────────────── */\n.hrcalendar-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.hrcalendar-month {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n/* ── Grid ────────────────────────────────────── */\n.hrcalendar-grid {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 4px 4px;\n}\n.hrcalendar-weekday {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  text-align: center;\n  padding: 4px 6px 8px;\n}\n.hrcalendar-weekday.is-weekend { color: #f87171; }\n\n/* ── Cell ────────────────────────────────────── */\n.hrcalendar-cell-wrap { padding: 0 2px; vertical-align: top; }\n\n.hrcalendar-cell {\n  width: 100%;\n  min-height: 64px;\n  padding: 8px 6px 6px;\n  border-radius: 10px;\n  border: 1.5px solid transparent;\n  background: #f8fafc;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  transition: all 0.15s ease;\n}\n.hrcalendar-cell:hover {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59,130,246,0.10);\n}\n.hrcalendar-cell.is-weekend {\n  background: #fefce8;\n}\n.hrcalendar-cell.is-weekend:hover {\n  background: #fef9c3;\n  border-color: #fde68a;\n}\n.hrcalendar-cell.is-today {\n  background: #eef2ff;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 2px #e0e7ff;\n}\n.hrcalendar-cell.is-selected {\n  background: #f0fdf4;\n  border-color: #22c55e;\n  box-shadow: 0 0 0 2px #dcfce7;\n}\n\n/* Date number */\n.hrcalendar-cell-date {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1;\n}\n.hrcalendar-cell.is-today .hrcalendar-cell-date {\n  color: #4f46e5;\n}\n.hrcalendar-cell.is-weekend .hrcalendar-cell-date {\n  color: #b45309;\n}\n\n/* ── Dots ────────────────────────────────────── */\n.hrcalendar-dots {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  justify-content: center;\n  min-height: 8px;\n}\n\n.hrcalendar-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* Dot colors by event type */\n.hrcalendar-dot--event     { background: #6366f1; }\n.hrcalendar-dot--holiday   { background: #ef4444; }\n.hrcalendar-dot--milestone { background: #f59e0b; }\n.hrcalendar-dot--training  { background: #0ea5e9; }\n.hrcalendar-dot--deadline  { background: #f43f5e; }\n.hrcalendar-dot--meeting   { background: #8b5cf6; }\n\n.hrcalendar-dot-more {\n  font-size: 9px;\n  font-weight: 700;\n  color: #64748b;\n  line-height: 1;\n  margin-top: 1px;\n}\n\n.hrcalendar-empty { min-height: 64px; }\n\n/* ── Selected Date Detail Panel ──────────────── */\n.hrcalendar-detail-panel {\n  margin-top: 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 14px;\n  background: #ffffff;\n  overflow: hidden;\n  animation: hrcal-slidein 0.18s ease;\n}\n\n@keyframes hrcal-slidein {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.hrcalendar-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\n  border-bottom: 1px solid #e2e8f0;\n}\n.hrcalendar-detail-title {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", sans-serif;\n}\n.hrcalendar-detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #94a3b8;\n  padding: 2px 6px;\n  border-radius: 6px;\n  transition: all .15s;\n}\n.hrcalendar-detail-close:hover {\n  background: #fee2e2;\n  color: #ef4444;\n}\n\n.hrcalendar-detail-empty {\n  padding: 20px 16px;\n  color: #94a3b8;\n  font-size: 13px;\n  text-align: center;\n}\n\n.hrcalendar-detail-list {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hrcalendar-detail-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n}\n.hrcalendar-detail-card--event {\n  background: #f5f3ff;\n  border-color: #ddd6fe;\n}\n.hrcalendar-detail-card--holiday {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n.hrcalendar-detail-card--milestone {\n  background: #fffbeb;\n  border-color: #fde68a;\n}\n.hrcalendar-detail-card--training {\n  background: #f0f9ff;\n  border-color: #bae6fd;\n}\n.hrcalendar-detail-card--deadline {\n  background: #fff1f2;\n  border-color: #fecdd3;\n}\n\n.hrcalendar-detail-card-left {\n  padding-top: 3px;\n}\n.hrcalendar-detail-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.hrcalendar-detail-card-body { flex: 1; }\n.hrcalendar-detail-card-title {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 3px;\n}\n.hrcalendar-detail-card-meta {\n  font-size: 11.5px;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n.hrcalendar-detail-card-desc {\n  margin-top: 6px;\n  font-size: 12.5px;\n  color: #334155;\n  line-height: 1.5;\n}\n\n/* ── Upcoming Events ─────────────────────────── */\n.hrcalendar-upcoming {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n.hrcalendar-upcoming-title {\n  font-size: 15px;\n  font-weight: 700;\n  font-family: \"Outfit\", sans-serif;\n  margin-bottom: 8px;\n  color: #1e293b;\n}\n.hrcalendar-empty-upcoming {\n  color: #94a3b8;\n  font-size: 13px;\n}\n.hrcalendar-upcoming-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.hrcalendar-upcoming-row:last-child { border-bottom: none; }\n.hrcalendar-upcoming-date {\n  font-size: 12px;\n  color: #64748b;\n  min-width: 90px;\n  font-weight: 600;\n}\n.hrcalendar-upcoming-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* ── Create actions ──────────────────────────── */\n.hrcalendar-create-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n/* ── Responsive ──────────────────────────────── */\n@media (max-width: 900px) {\n  .hrcalendar-month { font-size: 18px; }\n  .hrcalendar-cell  { min-height: 52px; padding: 6px 4px 4px; }\n  .hrcalendar-cell-date { font-size: 12px; }\n  .hrcalendar-dot { width: 6px; height: 6px; }\n  .hrcalendar-upcoming-row { flex-wrap: wrap; }\n  .hrcalendar-upcoming-date { min-width: unset; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
